// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
import React, { useEffect, useState } from "react";
import styles from "./categoryRepoDetails.module.css";
import axios from "axios";

function CategoryDetailsPopup({ repo, onClose }) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isFavourite, setIsFavourite] = useState(false);

  useEffect(() => {
    checkIsFavourite();
    const updateLastAccessed = async () => {
      try {
        await axios.post(
          `${apiUrl}/api/requests/recentlyAccessed/${repo.repository_id}`
        );
      } catch (error) {
        console.error("Error updating last accessed time:", error);
      }
    };

    updateLastAccessed();
  // eslint-disable-next-line no-use-before-define
  }, [apiUrl, checkIsFavourite, repo]); // runs whenever the repo is changed

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const checkIsFavourite = async () => {
    // the token is taken from the client side storage which will be fulfilled when the user is authenticated
    // the token is encoded as it doesnt respond without being encoded
    const token = localStorage.token;
    const jwtToken = encodeURIComponent(token);
    try {
      const response = await axios.get(
        `${apiUrl}/api/requests/isFavourite/${repo.repository_id}`,
        {
          headers: { Authorization: `Bearer ${jwtToken}` },
        }
      );
      // stores the value from the response to see if the repo has been favourited
      setIsFavourite(response.data.isFavourite);
    } catch (error) {
      console.error("Error checking favourite status:", error);
    }
  };

  const toggleFavourite = async () => {
    const token = localStorage.token;
    const jwtToken = encodeURIComponent(token);
    try {
      // changes which api endpoint is accessed by the axios request depending on whether the repo has been favourited already
      const endpoint = isFavourite
        ? "/removeFromFavourites"
        : "/addFavouriteRepository";
      await axios.post(`${apiUrl}/api/requests${endpoint}`, {
        token: jwtToken,
        repoId: repo.repository_id,
      });
      const action = isFavourite ? "removed from" : "added to";
      alert(`Repository ${action} favourites successfully`);
      setIsFavourite(!isFavourite);
    } catch (error) {
      console.error(
        `Failed to ${isFavourite ? "remove" : "add"} repository to favourites:`,
        error
      );
      alert(
        `Failed to ${isFavourite ? "remove" : "add"} repository to favourites`
      );
    }
  };

  return (
    <div className={styles.popupOverlay}>
      <div
        className={styles.popupContent}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <h2>{repo.repository_name}</h2>
        <p>Description: {repo.description}</p>
        <p>
          URL:{" "}
          <a
            href={repo.repository_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {repo.repository_url}
          </a>
        </p>
        <p>Languages: {repo.language}</p>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <p>Owner: </p>
          {repo.avatar && (
            <img
              src={repo.avatar}
              alt={`${repo.repository_author}'s avatar`}
              style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            />
          )}
          <p>{repo.repository_author}</p>
        </div>
        <p>Category: {repo.category}</p>
        <p>Category: {repo.access_level}</p>
        {repo.search_urls && repo.search_urls.length > 0 && (
          <>
            <h3>Search Results:</h3>
            <ul className={styles.searchUrls}>
              {repo.search_urls.map((url, index) => (
                <li key={index}>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    {url}
                  </a>
                </li>
              ))}
            </ul>
          </>
        )}
        <button onClick={toggleFavourite}>
          {isFavourite ? "Remove from Favourites" : "Add to Favourites"}
        </button>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default CategoryDetailsPopup;
